import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import RadioField from '@src/components/shared/form_fields/RadioField.vue';
import { AddressTypeModel } from '@src/view_models/AddressTypeModel';
import { ref, watch } from 'vue';

interface Props {
	disabledAddressTypes: AddressTypeModel[];
	isDirectDebit: boolean;
	addressTypeIsInvalid: boolean;
	initialAddressType?: AddressTypeModel;
	isMaxWidthField?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AddressType',
  props: {
    disabledAddressTypes: {},
    isDirectDebit: { type: Boolean },
    addressTypeIsInvalid: { type: Boolean },
    initialAddressType: {},
    isMaxWidthField: { type: Boolean }
  },
  emits: [ 'field-changed' ],
  setup(__props: any, { emit: __emit }) {


const props = __props;

const emit = __emit;

const addressType = ref<AddressTypeModel>( props.initialAddressType ?? AddressTypeModel.UNSET );

watch( addressType, newAddressType => {
	emit( 'field-changed', newAddressType );
} );

// When disabled address type is selected, revert to person type
watch( () => props.disabledAddressTypes, disabledAddressTypes => {
	// TODO This assumes that person will never be disabled.
	//      If this assumption is wrong, we need to have a fallback.
	if ( disabledAddressTypes !== undefined &&
		disabledAddressTypes.includes( addressType.value ) ) {
		addressType.value = AddressTypeModel.PERSON;
	}
} );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RadioField, {
    name: "addressType",
    id: "address-form-type",
    label: _ctx.$t('membership_form_section_address_header_type'),
    options: [
			{
				value: _unref(AddressTypeModel).PERSON,
				label: _ctx.$t( 'donation_form_addresstype_option_private' ),
				id: 'addressType-0',
			},
			{
				value: _unref(AddressTypeModel).COMPANY,
				label: _ctx.$t( 'donation_form_addresstype_option_company' ),
				id: 'addressType-1',
			},
		],
    disabled: __props.disabledAddressTypes,
    "show-error": __props.addressTypeIsInvalid,
    "error-message": _ctx.$t( 'donation_form_section_address_error' ),
    modelValue: addressType.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addressType).value = $event)),
    alignment: "column",
    "is-max-width-field": __props.isMaxWidthField
  }, null, 8, ["label", "options", "disabled", "show-error", "error-message", "modelValue", "is-max-width-field"]))
}
}

})